import { usePreorderWhyDialogStore } from "~/stores/preorder-why-dialog-store"
import PreorderWhyDialog from "./PreorderWhyDialog"

export function PreorderWhyDialogHost() {
  const { open, variantIds, skuIds, dateRange, closeDialog } = usePreorderWhyDialogStore()
  return (
    <PreorderWhyDialog
      variantIds={variantIds}
      skuIds={skuIds}
      dateRange={dateRange}
      open={open}
      onOpenChange={(o) => !o && closeDialog()}
    />
  )
}
